export const initialData = {
    nome: '',
    descricao: '',
  }
  export default initialData;
  